'use client';
import Nodata from "@/components/shared/no-data/Nodata";
import {useTranslations} from 'next-intl';
import CartProductItem from '@/components/shared/cart/CartProductItem';
import {useWishlistContext} from '@/providers/WshlistContext';

export default function WishlistPrimary() {
  const t = useTranslations('wishlist');
  const { wishlistProducts, updateWishlist } = useWishlistContext();
  
  const onDeleteProduct = async (product) => {
    updateWishlist(product);
  }
  
  return (
      <div className="liton__shoping-cart-area mb-50">
        <div className="container">
          <div className="mini-cart-product-area ltn__scrollbar">
            {
              Array.isArray(wishlistProducts) && wishlistProducts.length > 0 ? (
                  <>
                    {
                      wishlistProducts.map(({product, quantity}, idx) => {
                        return (
                            <div key={idx} className="mini-cart-item clearfix account-cart">
                              <CartProductItem
                                  product={product}
                                  quantity={quantity}
                                  onDeleteProduct={onDeleteProduct}
                              />
                            </div>
                        );
                      })
                    }
                  </>
            ) : (<Nodata text={t('wishlistEmpty')}/>)
          }
        </div>
      </div>
    </div>
  );
};
